// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__K-IOt"};